module.exports = __webpack_public_path__ + "svg/walley.edb9a8c2ac38348f9620429d5739542d.svg";